// Base class for components that want Bootstrap inside their shadow root.
//
// Extend this instead of LitElement and Bootstrap's classes work; keep using
// `static styles` for component-specific CSS on top. The shared sheets are
// adopted before the component's own, so `static styles` always wins.

import { LitElement } from './lit.js';
import { getSharedStyles } from './styles.js';

export class BaseComponent extends LitElement {
    async connectedCallback() {
        super.connectedCallback();
        await this._adoptSharedStyles();
    }

    async _adoptSharedStyles() {
        if (!this.shadowRoot || this._sharedStylesAdopted) return;

        const shared = await getSharedStyles();
        // Re-check: an await means the element may have been disconnected, or
        // another path may have adopted already.
        if (!this.shadowRoot || this._sharedStylesAdopted) return;

        // Prepend, so a component's own `static styles` override Bootstrap
        // rather than losing to it on equal specificity.
        this.shadowRoot.adoptedStyleSheets = [...shared, ...this.shadowRoot.adoptedStyleSheets];
        this._sharedStylesAdopted = true;
    }
}
